export default __webpack_public_path__ + "static/766-fa012013bd1a61ac5e31f2426af5cfde.gif";